export const NAMESPACE = 'telco';
export const RESOURCE = 'fiber_cable_nodes';
